module.exports = __webpack_public_path__ + "static/img/cont59 (3).07e7ec0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont59 (3).jpg
// module id = o9fg
// module chunks = 0